import { Box } from "@mui/system";
import React, { useState, useEffect, useCallback } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid } from "recharts";
import styles from "../components/turnoverGraph.module.scss";
import i18next from "i18next";
import { Tab, Tabs, Typography } from "@mui/material";
import _ from "lodash";
import { postTurnoverGraph } from "../../../services/APIService";
import { useApiErrorModalContext } from "../../../errorHandling/ApiErrorModalContext";

const sampYear = {
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mrt",
  Apr: "Apr",
  May: "Mei",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Okt",
  Nov: "Nov",
  Dec: "Dec",
};

const currentyear = new Date();

export default function TurnoverGraphComponent() {
  const [selectedTab, setSelectedTab] = useState(currentyear.getFullYear());

  const [dashboardTurnoverList, setDashboardTurnoverList] = useState([]);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const { setApiErrorModalState } = useApiErrorModalContext();

  const getGraphCurrentORpreviousValue = useCallback(() => {
    postTurnoverGraph({ period: selectedTab })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setDashboardTurnoverList(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  useEffect(() => {
    getGraphCurrentORpreviousValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  const processedData = dashboardTurnoverList.map((item) => ({
    CurentPreviousValue: sampYear[item.key],
    value: item.value,
  }));

  return (
    <>
      <Box
        className={styles.turngraphTableContainer}
        data-testid="TurnoverGraphComponent"
      >
        <Box>
          <Typography className={styles.turnOverheading}>
            {i18next.t("Turnover Total")}
            {`(${"€"})`}
          </Typography>
        </Box>
        <Box className={styles.GraphtabContainerheader}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            className={styles.toggelStyleTab}
            sx={{
              boxShadow:
                "0px 2px 4px 0px rgba(96, 97, 112, 0.16),0px 0px 1px 0px rgba(40, 41, 61, 0.04)",
            }}
          >
            <Tab
              label={i18next.t("Current Year")}
              className={styles.selectedDay}
              value={currentyear.getFullYear()}
            />
            <Tab
              label={i18next.t("Previous Year")}
              className={styles.selectedDay}
              value={currentyear.getFullYear() - 1}
            />
          </Tabs>
        </Box>
      </Box>
      <BarChart
        width={514}
        height={230}
        data={processedData}
        className={styles.turnbarChartContainer}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="CurentPreviousValue" />
        <YAxis dataKey="value" axisLine={false} />
        <Bar dataKey="value" fill="#0B72D9" />
      </BarChart>
    </>
  );
}
